import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { ConfigurationRuleScopeEntityType } from '@ydistri/api-sdk';
import React, { useCallback } from 'react';
import MultiselectScopeTag from './MultiselectScopeTag';

interface UseMultiselectScopeTagRenderOptions {
  disabled?: boolean;
  entityType: ConfigurationRuleScopeEntityType;
  tagWarnings?: Record<number, React.ReactNode | undefined>;
  missingIds?: number[];
}

const useMultiselectScopeTagRender = ({
  disabled = false,
  entityType,
  tagWarnings,
  missingIds,
}: UseMultiselectScopeTagRenderOptions): ((props: CustomTagProps) => React.ReactElement) =>
  useCallback(
    (props: CustomTagProps) => (
      <MultiselectScopeTag
        {...props}
        disabled={disabled}
        entityType={entityType}
        tagWarnings={tagWarnings}
        missingIds={missingIds}
      />
    ),
    [disabled, entityType, missingIds, tagWarnings],
  );

export default useMultiselectScopeTagRender;
